import React, { useId } from 'react'

interface ReminderListSkeletonProps {
  count?: number
}

export const ReminderListSkeleton: React.FC<ReminderListSkeletonProps> = ({
  count = 4,
}) => {
  const baseId = useId()

  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`${baseId}-${index}`}
          className="flex items-center gap-4 px-6 py-4 bg-white border border-solid rounded-lg border-gray-light-300"
        >
          <div className="flex-shrink-0">
            <div className="h-6 rounded-full w-11 bg-gray-light-200 animate-pulse" />
          </div>

          <div className="flex flex-col justify-center flex-1 min-w-0 gap-2">
            <div className="w-40 h-5 rounded bg-gray-light-200 animate-pulse" />
            <div className="w-64 h-4 rounded bg-gray-light-100 animate-pulse" />
          </div>

          {index % 2 === 0 && (
            <div className="flex items-center flex-shrink-0 gap-2">
              <div className="rounded w-9 h-9 bg-gray-light-200 animate-pulse" />
              <div className="rounded w-9 h-9 bg-gray-light-200 animate-pulse" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
